module.exports = __webpack_public_path__ + "img/transportation-and-storage-icon.c38118d3.svg";